<div class="minor-page-wrapper" fxLayout="column" fxLayoutAlign="start center">
    <div fxLayout="column" fxLayoutGap="10px" fxLayoutGap.lt-lg="20px" fxFlexFill>
         <!-- Grid. -->
        <div fxLayout="column" fxFlex>
            <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" fxFlex="40px">Year To Date
            </div>
            <div class="account-summaries-container" fxLayout.lt-lg="column" fxLayoutAlign="center stretch"
                fxFlex="200px">
                <div  fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                    <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxFlex>
                        <div class="summary-header-label" fxLayoutAlign="center center" fxFlex="35px">Interest and Lease Charges</div>
                        <div fxLayoutAlign="center center" fxFlex>
                            {{ interestCharges | number : '1.2' | customerGainLoss }}
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="10px" fxFlex>
                        <div class="summary-header-label" fxLayoutAlign="center center" fxFlex="35px">Service Fees</div>
                        <div fxLayoutAlign="center center" fxFlex>
                            {{ serviceFees | number : '1.2' | customerGainLoss }}</div>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                    <div fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="10px" fxFlex>
                        <div class="summary-header-label" fxLayoutAlign="center center" fxFlex="35px">Interest and Lease Credits</div>
                        <div fxLayoutAlign="center center" fxFlex>
                            {{ interestPaid | number : '1.2' | customerGainLoss }}</div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="10px" fxFlex>
                        <div class="summary-header-label" fxLayoutAlign="center center" fxFlex="35px">Realized Profit and (Loss)</div>
                        <div fxLayoutAlign="center center" fxFlex>
                            {{ profitLoss | number : '1.2' | customerGainLoss }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Table -->
        <div fxLayout="column" fxFlex>
            <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" fxFlex="40px">Cash Activity
            </div>
            <div class="mat-elevation-z8" fxFlex>
                <table mat-table [dataSource]="journalsDataSource" matSort #journalsSort="matSort">
                    <!-- Trade Date Column -->
                    <ng-container matColumnDef="effectDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.effectDate | date: 'MM/dd/yyyy' }} </td>
                    </ng-container>
                    <!-- Trans. # Column -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell *matCellDef="let element"> {{ element.inputDesc | cashDescription }} </td>
                    </ng-container>
                    <!-- Position Type -->
                    <ng-container matColumnDef="unitBal">
                        <th mat-header-cell class="cell-align-right" *matHeaderCellDef> Amount </th>
                        <td mat-cell class="cell-align-right" *matCellDef="let element">
                            {{ -element.inputDolAmt | number : '1.2-2' | minusSignToParens }} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="journalsColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: journalsColumns;"></tr>
                </table>
                <mat-paginator #journalsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>